import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import { withTranslation } from 'react-i18next';

class Privacy extends React.Component {
    render() {
        const { t } = this.props;
        return(
            <div className="App Terms">
                <Header  hide='true' hideSearch={true} />
                <main>
                    <h1>{t('pages.privacy.title')}</h1>
                    <p dangerouslySetInnerHTML={{ __html: t('pages.privacy.content') }} />
                </main>
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Privacy);